import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SERVICES } from "@/data";
import { Reveal, SectionLabel, CTAButton, requestInquiry } from "@/components/site/ui";

function ServiceRow({ item, index }) {
  const [hover, setHover] = useState(false);
  return (
    <Reveal delay={index * 0.06}>
      <div
        data-testid={`service-row-${index}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="group border-t border-black/10 py-10 lg:py-12 transition-colors duration-300 hover:bg-white"
      >
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-start px-0 lg:px-6">
          <div className="lg:col-span-1">
            <span className="font-heading font-extrabold text-2xl text-crimson">
              {item.num}
            </span>
          </div>

          <div className="lg:col-span-6">
            <h3 className="font-heading font-bold text-charcoal text-2xl sm:text-3xl lg:text-4xl tracking-tight">
              {item.title}
            </h3>
            <p className="mt-4 max-w-xl text-base text-muted-foreground leading-relaxed">
              {item.desc}
            </p>
            <div className="mt-6">
              <CTAButton
                testid={`service-book-btn-${index}`}
                variant="outline"
                onClick={() => requestInquiry("consultation", item.title)}
                className="!py-3 !px-6"
              >
                Book a Consultation
              </CTAButton>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative h-52 lg:h-64 overflow-hidden">
              <motion.img
                src={item.image}
                alt={item.title}
                initial={false}
                animate={{ scale: hover ? 1.06 : 1 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500"
              />
              <AnimatePresence>
                {hover && (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="absolute top-4 left-4 w-2 h-2 rotate-45 bg-crimson"
                  />
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </Reveal>
  );
}

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-36 bg-[#F5F5F7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionLabel>Immigration Services</SectionLabel>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <h2 className="font-heading font-bold text-charcoal text-4xl lg:text-6xl tracking-tight leading-[1.02]">
                Pathways to a life in Canada.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="border-b border-black/10">
          {SERVICES.map((item, i) => (
            <ServiceRow key={item.num} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
